<template>
   <div class="box">
      <el-form inline :model="sendDataInfo" ref="sendDataInfo" label-width="150px" :inline-message="false" :show-message="false">
         <el-row>
            <el-form-item label="发票类型" prop="billType" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-radio-group class="input" v-model="sendDataInfo.billType" size="medium">
                  <el-radio-button label="普票">普票</el-radio-button>
                  <el-radio-button label="专票">专票</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="开票日期" prop="invoicingTime" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <df-date :isdisabled="false" class="form_codition" v-model="sendDataInfo.invoicingTime" :isShowLong="false"></df-date>
            </el-form-item>
            <el-form-item label="推送方式" prop="pushMethod" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-radio-group class="input" v-model="sendDataInfo.pushMethod" size="medium">
                  <el-radio-button :label="0">不推送</el-radio-button>
                  <el-radio-button :label="1">短信</el-radio-button>
                  <el-radio-button :label="2">邮箱</el-radio-button>
                  <el-radio-button :label="3">全部</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item v-if="sendDataInfo.pushMethod==2||sendDataInfo.pushMethod==3" label="推送邮箱" prop="pushEmail" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-input class="input" v-model="sendDataInfo.pushEmail" clearable></el-input>
            </el-form-item>
            <el-form-item v-if="sendDataInfo.pushMethod==1||sendDataInfo.pushMethod==3" label="推送手机号" prop="pushPhone" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-input class="input" v-model="sendDataInfo.pushPhone" clearable></el-input>
            </el-form-item>
            <el-form-item label="税额汇总" prop="taxMoney" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-input class="input" disabled v-model="sendDataInfo.taxMoney" clearable></el-input>
            </el-form-item>
            <el-form-item label="发票总额汇总" prop="poolMoney" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-input class="input" disabled v-model="sendDataInfo.poolMoney" clearable></el-input>
            </el-form-item>
            <el-form-item label="发票含税总额汇总" prop="poolPsmoney" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-input class="input" disabled v-model="sendDataInfo.poolPsmoney" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
               <el-input class="input" type="textarea" :rows="2" v-model="sendDataInfo.remark"></el-input>
            </el-form-item>
         </el-row>
         <el-row>
            <el-form-item label="红冲类型" prop="redType" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-radio-group class="input" v-model="sendDataInfo.redType" size="medium" @input="inputChange">
                  <el-radio-button :label="0">整单红冲 </el-radio-button>
                  <el-radio-button :label="1">部分红冲</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="红冲原因" prop="rushReason" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
               <el-select class="input" v-model="sendDataInfo.rushReason" placeholder="请选择">
                  <el-option label="开票有误" value="01" v-if="sendDataInfo.redType!=1"></el-option>
                  <el-option label="销货退回" value="02"></el-option>
                  <el-option label="服务中止" value="03"></el-option>
                  <el-option label="销售折让" value="04"></el-option>
               </el-select>
            </el-form-item>
         </el-row>
      </el-form>
      <div class="table" v-if="sendDataInfo.redType==1">
         <el-table @select="selectChange" @select-all="selectChangeAll" ref="multipleTable" border :data="sendDataInfo.detailList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange"
                   size="small" height="300">
            <el-table-column type="selection" width="55" fixed="left"></el-table-column>
            <el-table-column label="通用名称" prop="bgmName" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="规格型号" prop="spec" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="计量单位" prop="bgpUnitmeasurement" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="总数量" prop="ddinCount" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="商品数量" prop="ddinCount1" min-width="120" show-overflow-tooltip>
               <template slot-scope="scope">
                  <el-input type="number" v-if="scope.row.bgmId!=''&&scope.row.bgmId!=null" v-model="scope.row.ddinCount1" @input="inputClick(scope.$index)"></el-input>
               </template>
            </el-table-column>
            <el-table-column label="含税价格" prop="psprice" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="含税金额" prop="psmoney" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="单价" prop="price" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="金额" prop="money" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="税率" prop="outRate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="税额" prop="taxMoney" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="类型" prop="type" min-width="120" show-overflow-tooltip>
               <template slot-scope="scope">
                  <span v-if="scope.row.type===0">正常行</span>
                  <span v-else-if="scope.row.type===1">折扣行</span>
                  <span v-else-if="scope.row.type===2">被折口行</span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="floor">
         <el-button type="primary" size="small" @click="sendDataAction('sendDataInfo')">保存</el-button>
         <el-button size="small" @click="closeClick">取消</el-button>
      </div>
   </div>
</template>

<script>
import NP from "number-precision";
export default {
   name: "makeInvoiceAction",
   props: ['actionData'],
   data() {
      return {
         sendDataInfo: {
            aimId: "",
            billType: "普票",
            businessId: "",
            businessType: "",
            cmId: "",
            cmName: "",
            dasmId: "",
            detailList: [],
            invoicingTime: "",
            originTicketNum: "",
            poolMoney: 0,
            poolPsmoney: 0,
            pushEmail: "",
            pushMethod: 0,
            pushPhone: "",
            redType: 0,
            remark: "",
            rushReason: "",
            taxMoney: 0
         },
         tableData1: [],
         tableData: [],
         selectData: [],
      }
   },
   watch: {
      selectData: {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.poolMoney = 0
            this.sendDataInfo.poolPsmoney = 0
            this.sendDataInfo.taxMoney = 0
            newValue.forEach((val, key) => {
               if (val.bgmId != "" && val.bgmId != null) {
                  this.sendDataInfo.poolMoney = this.$common.getDecimalInfo(3, NP.plus(val.money, this.sendDataInfo.poolMoney))
                  this.sendDataInfo.poolPsmoney = this.$common.getDecimalInfo(3, NP.plus(val.psmoney, this.sendDataInfo.poolPsmoney))
                  this.sendDataInfo.taxMoney = this.$common.getDecimalInfo(3, NP.plus(val.taxMoney, this.sendDataInfo.taxMoney))
               }
            })
         },
         deep: true,
      }
   },
   created() {
      this.openBox()
   },
   methods: {
      openBox() {
         for (const key in this.sendDataInfo) {
            if (key != 'detailList') {
               if (this.actionData.hz[key] != undefined && this.actionData.hz[key] != null && this.actionData.hz[key] !== "") {
                  this.sendDataInfo[key] = this.actionData.hz[key]
               }
            }
         }
         this.sendDataInfo.detailList = JSON.parse(JSON.stringify(this.actionData.mx))
         this.sendDataInfo.detailList.forEach(item => {
            this.$set(item, 'ddinCount1', item.ddinCount)
         })
         this.selectData = this.sendDataInfo.detailList
         // 批量处理输入计算
         this.sendDataInfo.detailList.forEach((item, index) => {
            if (item.bgmId != "" && item.bgmId != null) {
               this.inputClick(index, true);
            }
         });
      },
      selectChange(selection, row) {
         if (row.ddinCount1 == 0) {
            var index = this.sendDataInfo.detailList.findIndex(val => val.id == row.id)
            if (index != -1) {
               this.$set(this.sendDataInfo.detailList[index], 'ddinCount1', this.sendDataInfo.detailList[index].ddinCount)
            }
            var index1 = this.selectData.findIndex(val => val.id == this.sendDataInfo.detailList[index].id)
            if (index1 != -1) {
               this.selectData[index1] = this.sendDataInfo.detailList[index]
            }
         }

      },
      selectChangeAll(selection) {
         this.selectData.forEach(item => {
            if (item.ddinCount1 == 0) {
               item.ddinCount1 = item.ddinCount
               var index = this.sendDataInfo.detailList.findIndex(val => val.id == item.id)
               if (index != -1) {
                  this.$set(this.sendDataInfo.detailList[index], 'ddinCount1', this.sendDataInfo.detailList[index].ddinCount)
               }
            }
         })
      },
      handleSelectionChange(val) {
         this.selectData = val
      },
      inputClick(index, flag) {
         if (this.sendDataInfo.detailList[index].ddinCount1 > 0) {
            if (this.sendDataInfo.detailList[index].ddinCount1 > this.sendDataInfo.detailList[index].ddinCount) {
               this.sendDataInfo.detailList[index].ddinCount1 = this.sendDataInfo.detailList[index].ddinCount
            }
         } else if (this.sendDataInfo.detailList[index].ddinCount1 < 0) {
            if (this.sendDataInfo.detailList[index].ddinCount1 < this.sendDataInfo.detailList[index].ddinCount) {
               this.sendDataInfo.detailList[index].ddinCount1 = this.sendDataInfo.detailList[index].ddinCount
            }
         }

         this.$set(this.sendDataInfo.detailList[index], 'ddinCount1', this.$common.updataNum('ddinCount1', this.sendDataInfo.detailList[index]).ddinCount1)
         this.$set(this.sendDataInfo.detailList[index], 'psmoney', this.$common.getDecimalInfo(3, NP.times(this.sendDataInfo.detailList[index].psprice, this.sendDataInfo.detailList[index].ddinCount1)))
         this.$set(this.sendDataInfo.detailList[index], 'money', this.$common.getDecimalInfo(3, NP.times(this.sendDataInfo.detailList[index].price, this.sendDataInfo.detailList[index].ddinCount1)))
         this.$set(this.sendDataInfo.detailList[index], 'taxMoney', this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.detailList[index].psmoney, this.sendDataInfo.detailList[index].money)));
         var index1 = this.selectData.findIndex(val => val.id == this.sendDataInfo.detailList[index].id)
         if (index1 != -1) {
            this.selectData[index1] = this.sendDataInfo.detailList[index]
         }
         if (!flag) {
            if (this.sendDataInfo.detailList[index].ddinCount1 == 0) {
               this.$refs.multipleTable.toggleRowSelection(this.sendDataInfo.detailList[index], false)
            } else {
               this.$refs.multipleTable.toggleRowSelection(this.sendDataInfo.detailList[index], true)
            }
         }
      },
      inputChange() {
         this.sendDataInfo.rushReason = ""
         if (this.sendDataInfo.redType == 1) {
            this.sendDataInfo.detailList.forEach(item => {
               this.$set(item, 'ddinCount1', item.ddinCount)
            })
            this.$nextTick(() => {
               this.sendDataInfo.detailList.forEach(item => {
                  this.$refs.multipleTable.toggleRowSelection(item, true)
               })
            })
            this.selectData = this.sendDataInfo.detailList
         } else {
            this.sendDataInfo.detailList.forEach(item => {
               this.$set(item, 'ddinCount1', item.ddinCount)
            })
            this.selectData = this.sendDataInfo.detailList
            this.sendDataInfo.poolMoney = 0
            this.sendDataInfo.poolPsmoney = 0
            this.sendDataInfo.taxMoney = 0
            this.selectData.forEach((val, key) => {
               this.sendDataInfo.poolMoney = this.$common.getDecimalInfo(3, NP.plus(val.money, this.sendDataInfo.poolMoney))
               this.sendDataInfo.poolPsmoney = this.$common.getDecimalInfo(3, NP.plus(val.psmoney, this.sendDataInfo.poolPsmoney))
               this.sendDataInfo.taxMoney = this.$common.getDecimalInfo(3, NP.plus(val.taxMoney, this.sendDataInfo.taxMoney))
            })

         }
      },
      closeClick() {
         this.$emit('drawerCancel', false)
      },
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
            }
         });
      },
      async sub() {
         let sendData = {
            ...this.sendDataInfo
         }
         var arr = []
         this.selectData.forEach(item => {
            arr.push(this.sendDataInfo.detailList.filter(val => val.id == item.id)[0])
         })
         sendData.detailList = arr.map(item => {
            return {
               ...item,
               ddinCount: item.ddinCount1
            }
         })
         const res = await this.$http.redChong(sendData)
         if (res.status == 200) {
            this.$message.success(res.message)
            this.$emit('drawerCancel', true)
         } else {
            this.$message.error(res.message)
         }
      },
   },
   mounted() {

   }
}
</script>

<style scoped>
.box {
   position: relative;
   padding-bottom: 40px;
}
.input,
.form_codition {
   width: 250px !important;
}
::v-deep #dateinput {
   width: 250px !important;
}
.el-table {
   border-top: 1px solid #409eff !important;
}
.floor {
   position: absolute;
   bottom: 5px;
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: flex-end;
}
</style>